import React, { memo, useContext, useEffect } from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import { UserManagementPopup } from "../userManagement/userManagementPopup";
import { CssBaseline, styled, ThemeProvider } from "@mui/material";
import { ClinicRoute } from "../../clinic/ClinicRoutes";
import { ClinicPatientCard } from "./clinicPatientCard";
import { ScrollableContainer } from "fe-common/ui/commonStyles";
import { ClinicStateRouter } from "./clinicStateRouter";
import { getVersion } from "../../VersionInfo";
import packageInfo from "../../../package.json";
import { NewVersionPopover } from "fe-web-components/newVersionPopover";
import { NavBarZIndex } from "fe-common/ui/stacking";
import { ClinicTheme } from "fe-web-components/styles/clinicTheme";
import { OnboardRouter } from "./onBoarding/onboardRouter";
import { removeTrailingSlash } from "fe-common/routes/removeTrailingSlash";
import { PageTitleContext } from "../../context/pageTitleContext";
import { CommonColors } from "fe-web-components/colors/commonColors";

//region [[ Styled ]]
const ClinicView = styled(ScrollableContainer)({
  position: "fixed",
  width: "100%",
  height: "100%",
});

const ClinicNewVersion = styled(NewVersionPopover)(({ theme }) => ({
  zIndex: NavBarZIndex - 1,
  bottom: "43px",
  left: "29px",
  width: "310px",
  borderRadius: "4px",
  padding: "7.5px 16px",
  background: "white",
  color: CommonColors.Default,
  height: "48px",
  "& .close-button": { background: "white" },
  "& .close-button:hover": {
    background: "#d5d5d5",
  },
  "& .close-button svg": { fill: CommonColors.Default },
  "& .update-button": {
    color: CommonColors.Primary,
    background: CommonColors.White,
  },
  "& .update-button:hover": {
    background: CommonColors.Primary,
    color: CommonColors.White,
  },
  "& .new-version-text": {
    color: CommonColors.Default,
    width: "100%",
  },
  [theme.breakpoints.down("xs")]: {
    width: "95%",
    left: "2.5%",
    bottom: "2.5%",
  },
}));
//endregion [[Styled]]
export const ClinicContainer = memo(() => {
  const match = useRouteMatch();
  const currURL = removeTrailingSlash(match.url);

  //set clinic manage icon
  const pageTitle = useContext(PageTitleContext);
  useEffect(() => {
    pageTitle.setPageIcon("clinicfavico.ico");
  }, [pageTitle]);

  const currentVersion =
    getVersion() === "NA" ? packageInfo.version : getVersion();
  return (
    <ThemeProvider theme={ClinicTheme}>
      <CssBaseline />
      <ClinicView>
        <ClinicNewVersion
          direction={"up"}
          version={currentVersion}
          keepQueryParams
        />
        <UserManagementPopup />
        <Switch>
          <Route
            path={`${currURL}/patientCard`}
            component={ClinicPatientCard}
            exact
          />
          <Route
            path={[
              `${currURL}/${ClinicRoute.Start}`,
              `${currURL}/${ClinicRoute.Welcome}`,
              `${currURL}/${ClinicRoute.WelcomeToClinic}`,
              `${currURL}/${ClinicRoute.Login}`,
              `${currURL}/${ClinicRoute.Signup}`,
              `${currURL}/${ClinicRoute.ForgotPassword}`,
              `${currURL}/${ClinicRoute.New}`,
              `${currURL}/${ClinicRoute.Duplicate}`,
              `${currURL}/${ClinicRoute.ForgotPassword}/*`,
              `${currURL}/${ClinicRoute.New}/*`,
              `${currURL}/${ClinicRoute.Duplicate}/*`,
              `${currURL}/${ClinicRoute.Verify}`,
              `${currURL}/${ClinicRoute.Demo}`,
              `${currURL}/${ClinicRoute.Demo}/*`,
            ]}
            component={OnboardRouter}
            exact
          />
          <Route path={`${currURL}/:id`} component={ClinicStateRouter} />
          <Route path={currURL} component={ClinicStateRouter} exact />
        </Switch>
      </ClinicView>
    </ThemeProvider>
  );
});
